import styled from 'styled-components'

export const StyledInvoiceTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
